import { Divider } from 'antd'

import KAISTLOGO from '../images/KAIST_logo_tran.gif'
import KULOGO from '../images/KU_Logo.png'
import SIBALOGO from '../images/SIBA LOGO.png'

export default function Education() {
    return <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 24 }}><img src={KAISTLOGO} alt='KAIST LOGO' width='100' /></span>
            <span>
                <h2 style={{ margin: 0 }}><a href="https://kaist.ac.kr/en/">KAIST</a> (Korea Advanced Institute of Science and Technology)</h2>
                <h3 style={{ margin: 0 }}>M.S. in <a href="http://gsds.kaist.ac.kr">Data Science</a> (formerly, <a href="http://kse.kaist.ac.kr">Knowledge Service Engineering</a>)</h3>
                <h4 style={{ margin: 0 }}>Thesis: <a href="https://bit.do/patara-ms-thesis">Analysis of Dangerous Driving Behavior from Driving Log Data for Traffic Accident Risk Prediction</a></h4>
                <h4 style={{ margin: 0 }}>Advisor: <a href="https://dm.kaist.ac.kr/jaegil">Prof.Jae-Gil Lee</a>, GPA: 3.80 / 4.30</h4>
                <h5 style={{ color: '#4caf50' }}>FROM 2018 TO 2020</h5>
            </span>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 24, width: 100, textAlign: 'center' }}><img src={KULOGO} alt='KASETSART UNIVERSITY LOGO' width='64' /></span>
            <span>
                <h2 style={{ margin: 0 }}><a href="https://www.ku.ac.th/en/community-home">Kasetsart University</a></h2>
                <h3 style={{ margin: 0 }}>B.S. in <a href="https://cs.sci.ku.ac.th/">Computer Science</a> with First Class Honors</h3>
                <h4 style={{ margin: 0 }}>Advisor: <a href="https://cs.sci.ku.ac.th/personnel/academic/d1415/">Prof.Pakaket Wattuya</a>, GPA: 3.74 / 4.00</h4>
                <h5 style={{ color: '#4caf50' }}>FROM 2012 TO 2016</h5>
            </span>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 24 }}><img src={SIBALOGO} alt='SIBA LOGO' width='100' /></span>
            <span>
                <h2 style={{ margin: 0 }}>Santirat Institute of Business Administration College</h2>
                <h3 style={{ margin: 0 }}>Certificate of Vocational Edecation in Commerce (Business Computer)</h3>
                <h4 style={{ margin: 0 }}>GPA: 3.99 / 4.00</h4>
                <h5 style={{ color: '#4caf50' }}>FROM 2009 TO 2011</h5>
            </span>
        </div>
        <Divider>PRACTICE MAKES PERFECT</Divider>
    </>
}